/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SimpleUser } from './simple-user';

export interface IndividualPEP {
  readonly id: string;
  readonly modified_date: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly status: string;
  readonly comment: string;
  readonly added_by: SimpleUser;
  readonly report_file_url: string;
  readonly user: SimpleUser;
}
